<div class="confirmation-popup">
    <div class="popup-icon-wrap text-center">
        <div class="popup-icon-ring">
            <mat-icon class="alert-icon">priority_high</mat-icon>
        </div>
    </div>

    <mat-dialog-content class="popup-content text-center">
        <p class="content">{{ data.message }}</p>
    </mat-dialog-content>

    <mat-dialog-actions class="popup-actions" align="center">
        <button type="button" class="cancel-btn" mat-raised-button (click)="onAction(false)">No</button>
        <button type="button" class="confirm-btn" mat-raised-button (click)="onAction(true)">Yes</button>
    </mat-dialog-actions>
</div>